import { IDocument } from '../../types/builder';
import { IApplicationState } from '../../types/redux';

export const selectCertificates = (state: IApplicationState): IDocument[] => {
  const {
    builderCard: { certificates, certificatesImages },
  } = state;

  return [certificates, certificatesImages].filter(Boolean).flat() as IDocument[];
};
